import React from 'react';

const Forbidden = () => {
  return (
    <div>
        <h4>
            401 Not Authorized
        </h4>
    </div>
  );
};

export default Forbidden;
